"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var SuccessMessage = function (_a) {
    var message = _a.message;
    return ( // TODO REFACTOR TO USE MUI ALERT
    (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ p: 2, pr: 5, my: 2, width: "100%", bgcolor: "green.light", borderRadius: 1, display: "inline-flex" }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ mr: 1 }, { children: "\u2705" })), (0, jsx_runtime_1.jsx)("div", { children: message })] })));
};
exports.default = SuccessMessage;
